import { setCookie } from '@cian/utils/lib/browser/cookie';
import { LAST_HOPE_SHOWED_COOKIE_KEY } from '../../constants/lastHopePopup';

export function createCountPopupShowedCookie(count: number, timeStarted: number) {
  setCookie(LAST_HOPE_SHOWED_COOKIE_KEY, `${count}:${timeStarted}`, { expires: 365 * 86400, secure: false });
}
